import { useCallback, useReducer } from 'react';

import {
    SEND_EMAIL_CHOICE_ACTIONS,
    SEND_EMAIL_CHOICE_STATUSES,
} from '~/components/SendEmailChoice/constants/sendEmailChoice';
import {
    initialSendEmailChoiceState,
    sendEmailChoiceReducer,
} from '~/components/SendEmailChoice/reducers/sendEmailChoiceReducer';

export function useSendEmailChoice() {
    const [state, dispatch] = useReducer(sendEmailChoiceReducer, initialSendEmailChoiceState);

    return {
        isMissing: state.status === SEND_EMAIL_CHOICE_STATUSES.UNANSWERED && state.isMissing,
        // marks the required choice red when saving without an answer
        markMissing: useCallback(() => dispatch({ type: SEND_EMAIL_CHOICE_ACTIONS.MISSING_ON_SAVE }), []),
        onChange: useCallback(
            (sendEmail: boolean) => dispatch({ sendEmail, type: SEND_EMAIL_CHOICE_ACTIONS.CHOSEN }),
            [],
        ),
        reset: useCallback(() => dispatch({ type: SEND_EMAIL_CHOICE_ACTIONS.RESET }), []),
        sendEmail: state.status === SEND_EMAIL_CHOICE_STATUSES.ANSWERED ? state.sendEmail : null,
    };
}
